import * as Joi from "joi";
import { capitalize } from "lodash";
import * as React from "react";
import { toast } from "react-semantic-toasts";
import {
  Button,
  Form as UIForm,
  Icon,
  Message,
  Modal,
  Popup,
} from "semantic-ui-react";
import {
  Form,
  IInterfaceFormProps,
  IInterfaceFormState,
} from "src/components/Form";
import { IResource } from "./Base";

interface IInterfaceProps extends IInterfaceFormProps {
  resource: IResource;
  config: any;
  updated: (newName: string) => void;
}

interface IInterfaceState extends IInterfaceFormState {
  error: any;
  modelOpen: boolean;
}

export class UpdateResource extends Form<IInterfaceProps, IInterfaceState> {
  private static INITIAL_STATE = {
    data: {
      name: "",
    },
    error: null,
    errors: {},
    modelOpen: false,
  };

  private static schema: Joi.SchemaLike = {
    name: Joi.string().required().label("Name"),
  };

  constructor(props: IInterfaceProps) {
    super(props, UpdateResource.schema);
    this.state = {
      ...Form.FORM_INITAL_STATE,
      ...UpdateResource.INITIAL_STATE,
    };
  }

  public componentDidMount = () => {
    this.setState({ data: { name: this.props.resource.name } });
  };

  public componentDidUpdate = (prevProps, prevState) => {
    if (
      JSON.stringify(this.props.resource) !== JSON.stringify(prevProps.resource)
    ) {
      this.setState({ data: { name: this.props.resource.name } });
    }
  };

  public render() {
    const { error, modelOpen } = this.state;
    const { resource } = this.props;

    return (
      <Modal
        dimmer={true}
        size="tiny"
        open={modelOpen}
        onClose={this.handleCloseModel}
        trigger={
          <Popup
            content={`Edit ${resource.type.singular}`}
            position="bottom left"
            trigger={
              <Icon link={true} name="edit" onClick={this.handleOpenModel} />
            }
          />
        }
      >
        <Modal.Header>Edit {resource.type.singular}</Modal.Header>
        <Modal.Content>
          <UIForm onSubmit={this.handleSubmit}>
            {this.renderInput(
              "name",
              `${capitalize(resource.type.singular)} Name`
            )}
            {error && <Message error={true} header={error.message} />}
          </UIForm>
        </Modal.Content>

        <Modal.Actions>
          {this.renderSubmitButton("Save")}
          <Button secondary={true} onClick={this.handleCloseModel}>
            Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }

  private handleCloseModel = () => {
    this.setState({ modelOpen: false });
  };

  private handleOpenModel = () => {
    this.setState({ modelOpen: true });
  };

  protected doSubmit(callback: () => void) {
    const { data } = this.state;
    const { resource, updated, config, authUser } = this.props;
    const updatedConfig = {
      ...config,
      audit: {
        ...config.audit,
        updatedBy: authUser.uid,
      },
      name: data.name,
    };
    resource.api
      .updateName(resource.id, updatedConfig)
      .then(() => {
        callback();
        updated(data.name);
        this.handleCloseModel();
        toast({
          type: "success",
          icon: "info circle",
          title: `successfully updated ${resource.type.singular}  `,
          animation: "slide up",
          time: 5000,
        });
      })
      .catch((error: Error) => {
        callback();
        this.handleCloseModel();
        toast({
          type: "error",
          icon: "info circle",
          title: `failed to update ${resource.type.singular}  `,
          animation: "slide up",
          time: 5000,
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/UpdateResource.tsx